module.exports = __webpack_public_path__ + "img/LogoMin.85607ce2.png";